import PropTypes from "prop-types";
import React from 'react';

const SectionTitle = ({ Valuetitle,IPtitle,header2,centerText,ContactTitle,title,Htitle,Maintitle,MsubTitle, subTitle,subTitleC,ProdsubTitle,heading, titleOption, headingOption }) => {
    return (
        <div className={`section-title ${titleOption}`} style={{marginBottom:'10px'}} data-aos="fade-up">
            
            {ContactTitle?<h1 className={`title ${headingOption}`}  style={{color:'#1292ee', fontSize:'3rem'}}dangerouslySetInnerHTML={{__html: ContactTitle}}></h1> : ""}
            
            
            {heading? <h3 className={title} dangerouslySetInnerHTML={{__html: heading}}></h3> : ""} 
            {title?<h2 id="noJustify" className={`title ${headingOption}`} dangerouslySetInnerHTML={{__html: title}}></h2> : ""}
            {Htitle?<h2 style={{color:'#030e20'}}className={`title ${headingOption}`} dangerouslySetInnerHTML={{__html: Htitle}}></h2> : ""}

            {Maintitle?<h3 className={`title ${headingOption}`} style={{fontSize:'35px'}} dangerouslySetInnerHTML={{__html: Maintitle}}></h3> : ""}
            {Valuetitle?<h2 className={`title ${headingOption}`} style={{paddingTop:'20px',textAlign:'center' } } dangerouslySetInnerHTML={{__html: Valuetitle}}></h2> : ""}
            { IPtitle?  <h6 style={{fontSize:'1.2rem', color:'#030E22'}} className={`title`} dangerouslySetInnerHTML={{__html: IPtitle}}></h6> : ""}  
            { subTitle? <p style={{marginTop:'5px'}} className="sub-title">{subTitle}</p>: ""}   
            { MsubTitle? <p style={{marginTop:'10px',marginBottom:'3rem'}} id="centerText" className="sub-title">{MsubTitle}</p>: ""}   

            { header2? <p style={{margin:'5px 0 25px 0 '}} className="sub-title" dangerouslySetInnerHTML={{__html: header2}}></p>: ""}   
            { subTitleC? <p style={{margin:'15px 0 5px 0'}} className="sub-title">{subTitleC}</p>: ""}   
            { ProdsubTitle? <p style={{margin:'0px auto 35px auto'}} className="sub-title">{ProdsubTitle}</p>: ""}   
            
            {centerText?<p style={{marginTop:'0px'}} className="sub-title"  dangerouslySetInnerHTML={{__html: centerText}}></p>: ""}

        </div>
    )
}

SectionTitle.propTypes = {
    subTitle: PropTypes.string,
    MsubTitle:PropTypes.string,
    subTitleC: PropTypes.string,
    header2: PropTypes.string,
    ContactTitle: PropTypes.string,
    centerText: PropTypes.string,

    Htitle: PropTypes.string,
    ProdsubTitle: PropTypes.string,
    Maintitle: PropTypes.string,
    title: PropTypes.string,
    Valuetitle:PropTypes.string,
    IPtitle: PropTypes.string,
    heading: PropTypes.string,
    titleOption: PropTypes.string,
    headingOption: PropTypes.string
};
SectionTitle.defaultProps = {
    titleOption: "text-center",
    headingOption: "title"
};

export default SectionTitle;
